import React, { memo } from "react";
import useClosedChannelUI from '../../../hooks/inbox/ui/useClosedChannelUI';
import useSelectedConversation from "../../../hooks/shared/useSelectedConversation";

/**
 * Componente optimizado ClosedChannelMC
 * - Separa lógica de UI en hook useClosedChannelUI
 * - Memoiza handlers y renderButtons
 * - Mantiene estructura y clases Tailwind originales
 */
const ClosedChannelMC = memo(({
  message,
  type = "default",
  slug,
  onClick
}) => {
  const conversation = useSelectedConversation();
  // Hook de UI: maneja handlers y renderButtons
  const { renderButtons } = useClosedChannelUI({ conversation, type, slug, onClick });

  return (
    <div className="tw-wrapper tw-flex tw-w-full">
      <div className="tw-w-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-4">
        <div className="tw-px-5 tw-text-sm tw-text-gray-950 tw-break-words tw-text-center tw-mb-4">
          {message}
        </div>
        <div className="tw-flex tw-justify-center tw-gap-4">
          {renderButtons()}
        </div>
      </div>
    </div>
  );
});

ClosedChannelMC.displayName = "ClosedChannelMC";

export default ClosedChannelMC;
